import React from "react"
import BlogPreviewFormStyle from "./BlogPreviewFormStyle.module.styl"
import Check from "../../../../../../../assets/images/check.png"
import translate from "../../../../../../../translation/translator"
import keys from "../../../../../../../translation/keys"

const BlogPreviewForm = ({
  handleSubmit,
  email,
  handleChange,
  path,
  errors,
  loading,
  locale,
}) => {
  return (
    <React.Fragment>
      {loading === true ? (
        <div className="loader" />
      ) : (
        <form className={BlogPreviewFormStyle.holder}>
          <h2 className={BlogPreviewFormStyle.title}>
            {translate(keys.BLOG_PREVIEW_FORM_U_WANT, locale)}
          </h2>
          <p className={BlogPreviewFormStyle.description}>
            {translate(keys.BLOG_PREVIEW_FORM_JOIN_CLUB, locale)}{" "}
            <span>{translate(keys.BLOG_PREVIEW_FORM_FREE, locale)}</span>{" "}
            {translate(keys.BLOG_PREVIEW_FORM_RES, locale)}.{" "}
          </p>
          <div className={BlogPreviewFormStyle.features_holder}>
            <div className={BlogPreviewFormStyle.feature}>
              <div className={BlogPreviewFormStyle.item}>
                <img src={Check} alt="check" />
                <p>{translate(keys.BLOG_PREVIEW_FORM_SUECURE, locale)}</p>
              </div>
              <div className={BlogPreviewFormStyle.item}>
                <img src={Check} alt="check" />
                <p>{translate(keys.BLOG_PREVIEW_FORM_NO_SPAM, locale)}</p>
              </div>
            </div>
            <div className={BlogPreviewFormStyle.feature}>
              <div className={BlogPreviewFormStyle.item}>
                <img src={Check} alt="check" />
                <p>{translate(keys.BLOG_PREVIEW_FORM_ANON, locale)}</p>
              </div>
              <div className={BlogPreviewFormStyle.item}>
                <img src={Check} alt="check" />
                <p>{translate(keys.BLOG_PREVIEW_FORM_PDF, locale)}</p>
              </div>
            </div>
          </div>
          <input
            className={BlogPreviewFormStyle.input}
            type="text"
            name="EMAIL"
            onChange={handleChange}
            value={email}
            placeholder="Email"
          />
          {errors && <span className="blog-preview-error">{errors.email}</span>}
          <input type="hidden" value={path} name="URL" />
          <button
            className={BlogPreviewFormStyle.button}
            onClick={handleSubmit}
          >
            {translate(keys.BLOG_PREVIEW_FORM_SIGN_UP, locale)}
          </button>
        </form>
      )}
    </React.Fragment>
  )
}

export default BlogPreviewForm
